var map = {
	"./osmTagToNameMapping-cs.ts": [
		35356,
		5356
	],
	"./osmTagToNameMapping-en.ts": [
		78017,
		8017
	],
	"./osmTagToNameMapping-hu.ts": [
		9345,
		9345
	],
	"./osmTagToNameMapping-it.ts": [
		74987,
		4987
	],
	"./osmTagToNameMapping-sk.ts": [
		228,
		228
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;